import { useCollection } from '@amzn/awsui-collection-hooks';
import {
  Button,
  Link,
  Pagination,
  Table,
  TextFilter,
} from '@amzn/awsui-components-react';
import React, { useState } from 'react';
import { CommonDomainProps, SecurityGroups } from '../../../models/types';
import { getEndpoints } from '../../../utils/appConfig';
import {
  EmptyState,
  getFilterCounterText,
  Preferences,
} from './../../../utils/tablePreferences';
import {
  columns,
  DEFAULT_PREFERENCES,
  PAGE_SIZE_OPTIONS,
  VISIBLE_CONTENT_OPTIONS,
} from './columns';
import { ErrorMessageComponent } from "../../../ErrorHandler/errorMessageComponent";
import { ApiList }from "../../../ErrorHandler/utils";

interface SecurityGroupProps extends CommonDomainProps {
  securityGroups: SecurityGroups[];
  isLoading: boolean;
  errorMessage: string;
}

const SecurityGroup = (props: SecurityGroupProps) => {
  //const [selectedRow, getSelectedRow] = useState({} as any);

  const [preferences, setPreferences] = useState(DEFAULT_PREFERENCES);
  const {
    items,
    actions,
    filteredItemsCount,
    collectionProps,
    filterProps,
    paginationProps,
  } = useCollection(props.isLoading ? [] : props.securityGroups, {
    filtering: {
      empty: (
        <EmptyState
          title="No Security groups"
          subtitle="No security groups to display."
          action={<span></span>}
        />
      ),
      noMatch: (
        <EmptyState
          title="No matches"
          subtitle="We can’t find a match."
          action={
            <Button onClick={() => actions.setFiltering('')}>
              Clear filter
            </Button>
          }
        />
      ),
    },
    pagination: { pageSize: preferences.pageSize },
    sorting: {},
  });
  return (
      <div>
      {props.errorMessage ? (
        <ErrorMessageComponent errorMessage={props.errorMessage} apiName={ApiList.SECURITY_GROUPS}/>
      ) : (
    <Table
      {...collectionProps}
      columnDefinitions={[
        ...columns,
        {
          id: 'softwareVersion',
          header: 'Software version',
          cell: (e) => {
            return (
              <Link
                href={`${getEndpoints().apollo}/version_filter.html?versionInstance=${e.softwareVersion}`}
                external
              >
                {e.softwareVersion}
              </Link>
            );
          },
        },
      ]}
      stickyHeader={true}
      resizableColumns={true}
      wrapLines={preferences.wraplines}
      loading={props.isLoading}
      loadingText={
        props.isLoading ? 'Loading Security Groups' : 'No Security Groups found'
      }
      visibleColumns={preferences.visibleContent}
      items={items}
      pagination={
        <Pagination
          {...paginationProps}
          ariaLabels={{
            nextPageLabel: 'Next page',
            previousPageLabel: 'Previous page',
            pageLabel: (pageNumber) => `Page ${pageNumber} of all pages`,
          }}
        />
      }
      filter={
        <TextFilter
          {...filterProps}
          countText={getFilterCounterText(filteredItemsCount)}
          filteringAriaLabel="Filter instances"
        />
      }
      preferences={
        <Preferences
          preferences={preferences}
          setPreferences={setPreferences}
          disabled={false}
          pageSizeOptions={PAGE_SIZE_OPTIONS}
          visibleContentOptions={VISIBLE_CONTENT_OPTIONS}
        />
      }
    />
  )}
  </div>
  );
};

export { SecurityGroup };
